<template>
  <section
    ref="overlay"
    class="gf-overlay-filter"
    :class="{ '--opened': isOpenedModel }"
  >
    <div class="gf-overlay-filter__content">
      <div class="gf-overlay-filter__header">
        <gf-button
          v-if="canReturn"
          class="return-button"
          variant="outline-white"
          icon="gf-icon gf-icon-arrow-left"
          @click="returnFilterOverlay"
        ></gf-button>
        <h4>
          {{ headerTextModel }}
        </h4>
        <gf-button
          class="close-button"
          variant="outline-white"
          icon="gf-icon gf-icon-x"
          @click="closeFilterOverlay"
        ></gf-button>
      </div>
      <div class="gf-overlay-filter__filters">
        <slot name="filters"></slot>
      </div>
      <div class="gf-overlay-filter__actions">
        <gf-button
          v-if="hasReset"
          variant="outline-secondary"
          text="Сбросить"
          @click="onResetButtonClick"
        ></gf-button>
        <gf-button
          variant="primary"
          :text="submitButtonText"
          @click="onSubmitButtonClick"
        ></gf-button>
      </div>
    </div>
    <div class="gf-overlay-filter__filters-overlay">
      <slot name="filtersOverlay"></slot>
    </div>
  </section>
</template>

<script>
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';

export default {
  name: 'GfOverlayFilter',
  components: { GfButton },
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    headerText: {
      type: String,
      default: 'Фильтры'
    },
    canReturn: {
      type: Boolean,
      default: false
    },
    submitButtonText: {
      type: String,
      default: 'Показать результат'
    },
    hasReset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenedModel: false,
      headerTextModel: null
    };
  },
  watch: {
    isOpened() {
      this.isOpenedModel = this.isOpened;
      if (this.isOpenedModel) {
        document.querySelector('body').style.overflowY = 'hidden';
      } else {
        document.querySelector('body').style.overflowY = 'scroll';
      }
    },
    headerText() {
      if (this.headerText) {
        this.headerTextModel = this.headerText;
      }
    }
  },
  mounted() {
    this.isOpenedModel = this.isOpened;
    this.headerTextModel = this.headerText;
  },
  methods: {
    closeFilterOverlay() {
      this.$emit('close');
      this.$refs.overlay.style.display = 'none';
      setTimeout(() => {
        this.$refs.overlay.style.display = 'flex';
      }, 300);
      this.isOpenedModel = false;
    },
    returnFilterOverlay() {
      this.$emit('return');
      this.isOpenedModel = false;
    },
    onSubmitButtonClick() {
      this.$emit('submit');
      if (this.canReturn) {
        this.returnFilterOverlay();
      } else {
        this.closeFilterOverlay();
      }
    },
    onResetButtonClick() {
      this.$emit('reset');
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-overlay-filter';

#{$this} {
  display: flex;
  right: -200%;
  height: 100dvh;
  width: 200%;
  position: fixed;
  top: 0;
  background-color: var(--white);
  z-index: 33;
  pointer-events: none;
  transition: right 0.2s, opacity 0.25s 1ms;
  opacity: 0;
  justify-content: flex-start;
  align-items: flex-start;

  &.--opened {
    opacity: 1;
    right: -100%;
    pointer-events: all;
    transition: right 0.3s;

    & > #{$this}__content {
      #{$this}__header {
        opacity: 1;
        right: 0;
        pointer-events: all;
        transition: right 0.3s;
      }

      #{$this}__actions {
        opacity: 1;
        right: 0;
        pointer-events: all;
        transition: right 0.3s;
      }
    }

    &:has(&.--opened) {
      right: 0;

      & > #{$this}__content {
        #{$this}__header {
          right: 100%;
        }

        #{$this}__actions {
          right: 100%;
        }
      }
    }
  }

  #{$this}__content {
    width: 50%;
    max-height: 100%;
    padding: 70px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    overflow: auto;

    #{$this}__header {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 14px;
      position: fixed;
      top: 0;
      padding: 14px 28px;
      background-color: var(--white);
      width: 100%;
      z-index: 33;

      right: -100%;
      pointer-events: none;
      transition: right 0.2s, opacity 0.25s 1ms;
      opacity: 0;

      & > h4 {
        margin-bottom: 0;
      }

      & .close-button {
        margin-left: auto;
      }

      & .return-button {
        min-width: 32px;
        padding-left: 0;
        color: var(--text);
      }
    }

    #{$this}__actions {
      width: 100%;
      position: fixed;
      bottom: 0;
      right: -100%;
      padding: 14px 28px;
      z-index: 33;
      display: flex;
      gap: 8px;
      opacity: 0;
      background-color: var(--white);
      pointer-events: none;
      transition: right 0.2s, opacity 0.25s 1ms;

      & > button {
        width: 100%;
      }
    }

    #{$this}__filters > div {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
  }
}
</style>
